<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
        <vs-card style="border-radius: 1.5em;">
          <div slot="header">
            <h3 class="card-title mb-0">Información de filtro</h3>
          </div>
          <b-loading
              :is-full-page="true"
              v-model="isLoading"/>
          <vs-row>
            <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
              <!-- Selector de empresa -->
              <company-selector v-model="companyId"/>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Integración contable</label>
              <multiselect v-model="typeIntegration"
                           placeholder="Seleccione software contable"
                           label="name"
                           track-by="code"
                           :options="showIntegrationsList"
                           :multiple="false"
                           :taggable="true"
                           :max-height="150"
                           :max="50">
              </multiselect>
            </vs-col>
          </vs-row>
          <hr class="custom-hr"/>
          <div class="d-inline-block d-md-flex align-items-center">
            <div class="btn-alignment">
              <vs-button @click="searchIntegration()">Buscar</vs-button>
              <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
            </div>
          </div>
        </vs-card>
      </vs-col>
    </vs-col>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12" v-if="viewDetail">
      <vs-card style="border-radius: 1.5em;">

        <h3 class="card-title ">Datos de configuración</h3>

        <hr class="custom-hr"/>
        <vs-row>
          <vs-col vs-lg="3" vs-xs="12" vs-sm="12"
                  v-for="(field, index) in dynamicFields"
                  :key="index">
            <dynamic-field :field="field" :edit="editIntegration"/>
          </vs-col>
        </vs-row>

        <hr class="custom-hr"/>
        <div class="d-inline-block d-md-flex align-items-center">
          <div class="btn-alignment">
            <vs-button color="success" @click="saveConfig">Guadar configuración</vs-button>
          </div>
          <div class="ml-auto" v-if="!editIntegration">
            <vs-button @click="editIntegration=true" color="primary" type="filled" class="mt-4 mt-md-0">
              <i class="mdi mdi-border-color mr-1"></i> Editar configuración
            </vs-button>
          </div>
        </div>
      </vs-card>
    </vs-col>

  </vs-row>

</template>
<script>
import companySelector from "@/components/Shared/CompanySelector/index.vue";
import multiselect from "vue-multiselect";
import unityEndpoint from "@/endpoints/core/UnityEndpoint";
import integrationEndpoint from "@/endpoints/reports/IntegrationEndpoint";
import integrationPropertyEndpoint from "@/endpoints/reports/IntegrationPropertyEndpoint";
import dynamicField from "@/views/configuration/accounting-integration/dynamic-field/dynamic-field.vue";
import toast from "@/global/ToastConfig";
import EKind from "@/global/lasting/EKind";

export default {
  components: {
    multiselect,
    companySelector,
    dynamicField
  },
  data() {
    return {
      companyId: null,
      integrationCode: null,
      viewDetail: false,
      showIntegrationsList: [],
      typeIntegration: null,
      isLoading: false,
      dynamicFields: [],
      editIntegration: true
    }
  },
  watch: {
    companyId() {
      this.dynamicFields = [];
      this.viewDetail = false;
      this.editIntegration = false;
      this.integrationCode = null;
    },
    typeIntegration() {
      this.dynamicFields = [];
      this.viewDetail = false;
      this.editIntegration = false;
      this.integrationCode = null;
    },
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    /**
     * Limpia todos los datos del formulario
     */
    clearForm() {
      this.integrationCode = null;
      this.viewDetail = false;
      this.companyId = null;
      this.typeIntegration = null;
      this.dynamicFields = [];
    },
    /***
     * prepara los parametros de búsqueda
     * @returns {{companyId: null, typeId}}
     */
    prepareParametersIntegration() {
      return {
        companyId: this.companyId,
        typeId: this.typeIntegration.code
      }
    },
    /**
     * valida  los campos de filtro iniciales que esten diligenciados
     */
    validateSearchForm() {
      if (!this.companyId) {
        throw new Error("Seleccione una compañía");
      }
      if (!this.typeIntegration) {
        throw new Error("Seleccione un software contable");
      }
    },
    /**
     * Método que valida los datos antes de guardar
     * @param listIntegration la lista con los datos a validar
     */
    validateSaveIntegration(listIntegration) {
      listIntegration.forEach(item => {
        if (item.value === '' || item.value == null) {
          throw new Error("El campo " + item.title + " es obligatorio");
        }
      })
    },
    /**
     * llamada a endPoint que trae todas las unidades de tipo integración
     */
    getIntegrations() {
      try {
        this.isLoading = true;
        unityEndpoint.getUnityListByKind(EKind.INTEGRATION_TYPES)
            .then(unityListIntegration => {
              if (unityListIntegration == null) {
                this.isLoading = false
                return
              }
              unityListIntegration.forEach(integrationConfig => {
                const integration = {
                  name: integrationConfig.title,
                  code: integrationConfig.code,
                };
                this.showIntegrationsList.push(integration);
              });
              this.isLoading = false;
            });
      } catch (error) {
        toast.error(error.toString())
      }
    },
    /**
     * Búsqueda de integracion por tipo y compañía
     * @returns {Promise<void>}
     */
    searchIntegration() {
      try {
        this.dynamicFields = [];
        this.viewDetail = false;
        this.isLoading = true;
        this.validateSearchForm();
        const params = this.prepareParametersIntegration();
        integrationEndpoint.findByCompanyAndType(params)
            .then(data => {
              if (data.code === 0) {
                toast.info(data.message)
                this.findProperty();
                this.isLoading = false;
                return;
              }
              this.previewIntegration();
              this.isLoading = false;
            })
      } catch (error) {
        toast.error(error.toString())
        this.isLoading = false;
      }
    },
    /***
     * llamada para traer una integracion con las propiedades de configuración
     */
    previewIntegration() {
      try {
        const params = this.prepareParametersIntegration();
        integrationEndpoint.getWithProperties(params)
            .then(data => {
                  this.viewDetail = true;
                  const fieldList = JSON.parse(data.info.integrationProperty.fields)
                  const integrationInfo = JSON.parse(data.info.info);
                  this.integrationCode = data.info.code;
                  this.setPreviewData(fieldList, integrationInfo);
                  this.dynamicFields.push(...fieldList);

                }
            )
      } catch (error) {
        toast.error(error.toString())
      }
    },
    /**
     * trae las propiedades de un tipo de integración
     */
    findProperty() {
      this.isLoading = true;
      const params = this.prepareParametersIntegration();
      integrationPropertyEndpoint.findByType(params)
          .then(data => {
            this.viewDetail = true;
            const fieldList = JSON.parse(data.info.fields);
            this.dynamicFields.push(...fieldList);
            this.editIntegration = true;
            this.isLoading = false;
          })
    },

    /**
     * Método para guardar integracion de software contable l
     */
    saveConfig() {
      try {
        this.isLoading = true;
        this.validateSaveIntegration(this.dynamicFields);
        const integrationEntity = {
          code: this.integrationCode,
          company: {
            code: this.companyId
          },
          integrationType: {
            code: this.typeIntegration.code
          },
          info: this.assembleInfo(this.dynamicFields)
        }
        integrationEndpoint.saveIntegration(integrationEntity)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              this.viewDetail = false;
              this.dynamicFields = [];
              this.isLoading = false;
              this.editIntegration = false;

            })

      } catch (error) {
        toast.error(error.toString())
        this.isLoading = false;
      }
    },
    /**
     * asigna valores a los registros del formulario cuan ya hay información
     * @param fields registros
     * @param values valores
     */
    setPreviewData(fields, values) {

      for (var i = 0; i < fields.length; i++) {
        var key = fields[i].key;
        fields[i].value = values[0][key];
      }
    },
    /**
     * construye el string  json con los registros del formulario
     * @param listFields
     * @returns {string}
     */
    assembleInfo(listFields) {
      const listInfo = [];
      const info = {};
      for (const field of listFields) {
        info[field.key] = field.value;
      }
      listInfo.push(info);
      return JSON.stringify(listInfo);
    }

  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
